var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMedication = function SvgMedication(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 3H7.6C7.17565 3 6.76869 3.16556 6.46863 3.46026C6.16857 3.75496 6 4.15466 6 4.57143V7.71429C6 8.13105 6.16857 8.53075 6.46863 8.82545C6.76869 9.12015 7.17565 9.28571 7.6 9.28571V23.4286C7.6 23.8453 7.76857 24.245 8.06863 24.5397C8.36869 24.8344 8.77565 25 9.2 25H18.8C19.2243 25 19.6313 24.8344 19.9314 24.5397C20.2314 24.245 20.4 23.8453 20.4 23.4286V9.28571C20.8243 9.28571 21.2313 9.12015 21.5314 8.82545C21.8314 8.53075 22 8.13105 22 7.71429V4.57143C22 4.15466 21.8314 3.75496 21.5314 3.46026C21.2313 3.16556 20.8243 3 20.4 3ZM9.2 12.4286H11.6V20.2857H9.2V12.4286ZM18.8 23.4286H9.2V21.8571H11.2C12.3046 21.8571 13.2 20.9617 13.2 19.8571V12.8571C13.2 11.7526 12.3046 10.8571 11.2 10.8571H9.2V9.28571H18.8V23.4286ZM7.6 7.71429V4.57143H20.4V7.71429H7.6Z",
    fill: "#B5B5B5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedication, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medication.d292fb70.svg";
export { ForwardRef as ReactComponent };